import { GetLockerOrderDetailsState } from './getLockerOrderDetails.types'

const getLockerOrderDetailsInitialState: GetLockerOrderDetailsState = {
  loading: false,
  error: null,
  success: null
}

export default getLockerOrderDetailsInitialState
